import { render } from "./reportContent.vue?vue&type=template&id=074b1fd0&scoped=true&ts=true"
import script from "./reportContent.vue?vue&type=script&lang=ts"
export * from "./reportContent.vue?vue&type=script&lang=ts"

import "./reportContent.vue?vue&type=style&index=0&id=074b1fd0&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074b1fd0"]])

export default __exports__